import { useNavigate, useParams } from "react-router-dom";
import { Button, Loading, Panel, Typography } from "@/components/atoms";
import { useGetDebitsDetailsQuery } from "@/redux/apis/payment/stripe/stripeApi";
import { useAppSelector } from "@/redux/hooks";
import { stripeSelector } from "@/redux/slices/payment/selectors";
import { clsx } from "@/utils";
import { DebitsDetails } from "./contents/DebitsDetails";
import { DebitsEditor } from "./contents/DebitsEditor";
import { renderDetailsStatus } from "./helpers";

export const BankDetailsDebitsPanel = () => {
  const { mode, type } = useParams();
  const navigate = useNavigate();
  const { isFetching } = useGetDebitsDetailsQuery();
  const { debits } = useAppSelector(stripeSelector);
  const isBlankDetails = Boolean(!debits.id);

  return (
    <Panel className={clsx({ "pointer-events-none opacity-50": mode === "edit" && type !== "debit" })}>
      <Typography variant="h3">Bank Details - Debits</Typography>
      <div className="relative mt-6 flex flex-col gap-[15px] lg:flex-row lg:gap-[30px]">
        {isFetching && <Loading />}
        {mode === "edit" && type === "debit" ? (
          <DebitsEditor />
        ) : (
          <DebitsDetails className={clsx({ "border border-warning-dark": isBlankDetails })} debits={debits} />
        )}
        <div className="flex flex-1 flex-col">
          {renderDetailsStatus(isBlankDetails, mode)}
          <Typography variant="paragraph">
            Note: We will request funds daily to settle any outstanding balance you have on your account. Please ensure there are sufficient
            funds daily otherwise fees may apply and loss of service may occur.
          </Typography>
          {!(mode === "edit" && type === "debit") && (
            <div className="mt-4 flex flex-row gap-x-4">
              <Button variant="primary" onClick={() => navigate("./debit/edit")}>
                Edit
              </Button>
              <Button variant="secondary" onClick={() => navigate("./debit/history")}>
                View History Logs
              </Button>
            </div>
          )}
        </div>
      </div>
    </Panel>
  );
};
